/**
 * @module ui/jump-box
 * @description The prototype object for the "jump box" component
 */
import { qs } from "utils/utils";
import isFunction from "lodash/isFunction";

const JumpBoxPrototype = {
  init(rootEl, callback = null) {
    if (!rootEl) {
      return;
    }
    this.el = rootEl;
    this.form = qs(".c-form", rootEl);
    this.select = qs(".c-form__control--select", rootEl);
    this.onSubmitBound = this.onSubmit.bind(this);
    this.callback = callback;
    this.enabled = null;
  },

  enable() {
    if (this.enabled === true || !this.form || !this.select) {
      return;
    }
    this.form.addEventListener("submit", this.onSubmitBound);
    this.enabled = true;
  },

  disable() {
    if (this.enabled === false || !this.form || !this.select) {
      return;
    }
    this.form.removeEventListener("submit", this.onSubmitBound);
    this.enabled = false;
  },

  onSubmit(event) {
    event.preventDefault();
    event.stopPropagation(); // Required for Element.scrollIntoView() smooth scrolling

    if (isFunction(this.callback)) {
      this.callback(this.select.options[this.select.selectedIndex]);
    }
  }
};

export default JumpBoxPrototype;
